import React from "react";
import { Info, Warning } from "@phosphor-icons/react";

/**
 * Reusable, non-legal-claim disclaimer notice.
 *
 * variant:
 *   "ai"      — AI output may be incorrect / requires human review
 *   "medical" — not a medical service; pain reports aren't emergencies
 *   "coach"   — program changes need coach approval
 */
const COPY = {
  ai: {
    icon: Info,
    title: "AI GUIDANCE — REVIEW BEFORE USE",
    body: "AI suggestions can be incomplete or incorrect. Treat them as a starting point, not instructions. Review everything with a qualified coach before training, and stop if anything causes pain.",
  },
  medical: {
    icon: Warning,
    title: "NOT A MEDICAL SERVICE",
    body: "Edge Training does not diagnose, treat or manage injuries. Pain and readiness reports are shared with your coach for review only — they are not monitored in real time and are not an emergency service. If you are hurt or unwell, seek qualified medical care.",
  },
  coach: {
    icon: Info,
    title: "COACH-MANAGED",
    body: "Changes to a coach-assigned program take effect only after your coach reviews and approves them. Prescribed targets stay separate from your logged results.",
  },
};

export function Disclaimer({ variant = "ai", className = "", testid }) {
  const meta = COPY[variant] || COPY.ai;
  const Icon = meta.icon;
  return (
    <div
      className={`flex items-start gap-2.5 border border-amber-400/30 bg-amber-400/5 px-3 py-2.5 rounded-sm ${className}`}
      data-testid={testid || `disclaimer-${variant}`}
      role="note"
    >
      <Icon size={16} weight="fill" className="text-amber-400 flex-shrink-0 mt-0.5" />
      <div>
        <div className="label-tiny text-amber-400 tracking-wider mb-0.5">{meta.title}</div>
        <div className="text-[11px] leading-snug text-text-secondary">{meta.body}</div>
      </div>
    </div>
  );
}

export default Disclaimer;
